export const QTY_INPUT = 'qty_input';

export const QTY_WITH_EXPIRY_INPUT = 'qty_with_expiry_input';

export const QTY_FIELD_ACTION_MODES = {
  DISABLE_VERIFY: 'DISABLE_VERIFY',
  ENABLE_VERIFY: 'ENABLE_VERIFY',
  ENABLE_ADD: 'ENABLE_ADD',
};
